import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const TopNavbar = ({ setLoginModalOpen, toggleSidebar }) => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const openDocs = () => {
    navigate('/docs'); // Redirect to the login/registration page
  };
  const handleLogout = () => {
    logout(); // Clear the token and update state
    navigate('/'); // Redirect to the login/registration page
  };

  return (
    <nav className="navbar navbar-dark bg-dark px-3">
      {/* Sidebar Toggle Button */}
      {isAuthenticated() && (
        <button
          className="btn btn-outline-light me-2"
          onClick={toggleSidebar}
        >
          ☰
        </button>
      )}
      <span className="navbar-brand">Network Security Console</span>
      <div>
        {/* Login or Logout Button */}
        {isAuthenticated() ? (
          <>
          <button
            className="btn btn-light me-2"
            onClick={openDocs}
          >
            Help
          </button>
          <button className="btn btn-danger" onClick={handleLogout}>
            Logout
          </button>
          </>
        ) : (
          <button className="btn btn-success" onClick={() => setLoginModalOpen(true)}>
            Login
          </button>
        )}
      </div>
    </nav>
  );
};

export default TopNavbar;
